import { useParams } from "react-router-dom";
import { Skeleton } from "@/components/ui/skeleton";
import { useApi } from "@/lib/api";
import { useCloudProject } from "@/hooks/useProjectStore";
import { ProjectView } from "@/components/project/ProjectView";

export default function Project() {
  const { id } = useParams();
  const api = useApi();
  const store = useCloudProject(id, api);

  if (!store.project) {
    return (
      <div className="flex h-screen flex-col" data-testid="project-loading">
        <Skeleton className="h-16 w-full rounded-none" />
        <div className="flex flex-1"><Skeleton className="m-4 flex-1" /><Skeleton className="m-4 hidden w-96 lg:block" /></div>
      </div>
    );
  }

  return <ProjectView {...store} api={api} />;
}
